import axios from 'axios';
import Swal from 'sweetalert2';

// Shared session expiration handler
const handleSessionExpiration = (error) => {
    if (error.response && error.response.status === 401) {
        const isAdminRoute = window.location.pathname.startsWith('/admin');
        const isSuperAdminRoute = window.location.pathname.startsWith('/superadmin');
        
        if ((isAdminRoute || isSuperAdminRoute) && !window.isGlobalSessionExpiredAlertShown) {
            window.isGlobalSessionExpiredAlertShown = true;
            Swal.fire({
                icon: 'warning',
                title: 'Session Expired',
                text: 'Your session has expired due to inactivity. Please log in again to continue.',
                confirmButtonText: 'Continue',
                confirmButtonColor: '#007bff',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then((result) => {
                if (result.isConfirmed) {
                    if (isSuperAdminRoute) {
                        localStorage.removeItem('superAdminToken');
                        localStorage.removeItem('superAdminInfo');
                        window.location.href = '/superadmin/login';
                    } else {
                        localStorage.removeItem('authToken');
                        localStorage.removeItem('userInfo');
                        localStorage.removeItem('userSessionData');
                        window.location.href = '/login';
                    }
                }
            });
        }
    }
    return Promise.reject(error);
};

// Global Axios Interceptor for Session Expiration on default instance
axios.interceptors.response.use((response) => response, handleSessionExpiration);

// Patch axios.create to attach the global interceptor to all custom instances
const originalAxiosCreate = axios.create;
axios.create = function() {
    const instance = originalAxiosCreate.apply(this, arguments);
    instance.interceptors.response.use((response) => response, handleSessionExpiration);
    return instance;
};
